<template>
  <section class="customer">
    <ul class="customer__row">
      <li class="customer__left">
        <div class="customer__txtBox">
          <h2 class="subtitle">
            찾아 오시는 길
          </h2>
          <address class="description">
            서울시 마포구 동교로 107 홍익제일빌딩 202호
          </address>
          <div class="customer__map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d813.0199324468625!2d126.91390541609853!3d37.554763679032355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c98d9acbc2fb7%3A0x6bd0b7b6de925cf3!2z7ISc7Jq47Yq567OE7IucIOuniO2PrOq1rCDshJzqtZDrj5kg64-Z6rWQ66GcIDEwNw!5e0!3m2!1sko!2skr!4v1608794199993!5m2!1sko!2skr" 
              width="500"
              height="290"
              frameborder="0"
              style="border:0;"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            />
          </div>
        </div>
      </li>
      <li class="customer__right">
        <div class="customer__txtBox">
          <h2 class="subtitle">
            더 궁금하신 내용이 있나요?
          </h2>
          <p class="description">
            아래 문의하기를 통해 신속하게 답변을 받아 보실 수 있습니다.<br>
            유선상담을 원하실 경우 연락처를 남겨 주세요.
          </p>
          <ul class="customer__buttons">
            <li class="customer__buttonitem">
              <button
                type="button"
                class="button button--primary"
                @click="openModal('request')"
              >
                프로젝트 의뢰하기
              </button>
            </li>
            <li class="customer__buttonitem">
              <button
                type="button"
                class="button"
                @click="openModal('inquiry')"
              >
                문의하기
              </button>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <img src="@/assets/images/img_mailbox.png">
  </section>
</template>

<script>
export default {
  name: 'Customer',
  components:{
  },
  data() {
    return {}
  },
  created() {
	},
  methods: {
    openModal(target) {
      if (target === 'request') {
        this.$gtag.query('event', 'Request', {
          app_name: 'UILab Homepage',
          screen_name: 'Request Popup',
        })
      }
      this.$store.commit('modalOpen', target)
    },
  }
}
</script>

<style lang="scss" scoped>
.customer{
  $self:&;
  width:1000px;
  height:auto;
  margin:0 auto;
  padding:100px 0 110px 0;
  position: relative;
  img {
    position: absolute;
    bottom:-35px;
    right:150px;
    animation: flicker 6s ease alternate infinite;
  }
  &:after{
    content:'';
    clear:both;
    display:block;
  }  
  &__row{
    padding-top:51px;
    &:after{
      content:'';
      clear:both;
      display:block;
    }  
    &:not(:last-child){
      padding-top:40px;
    }
  }
  &__left{
    float:left;
    width:50%;
  }
  &__map{
    padding-top:10px;
  }
  &__right{
    float:left;
    padding-left:50px;
    height:338px;
    width:50%;
    background: url('~@/assets/images/img-question.png') no-repeat 301px 129px;
    background-size:185px 209px;
  }
  &__buttons{
    padding-top:30px;
    &:after{
      clear:both;
      content:'';
      display:block;
    }
  }
  &__buttonitem{
    width:136px;
    height: 40px;
    float:left;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
@keyframes flicker {
  0% {
    transform: scale(1, 0) translateY(-20px)
  } 2% {
    transform: scale(1, 1.05) translateY(-30px)
  } 3% {
    transform: scale(1, 1) translateY(0)
  } 68% {
    transform: scale(1, 1) translateY(0)
  } 76% {
    transform: scale(1, .95) translateY(0)
  } 77% {
    transform: scale(1, 1.05) translateY(-30px)
  } 79% {
    transform: scale(1, 0) translateY(-20px)
  } 100% {
    transform: scale(1, 0) translateY(-20px)
  }
}

</style>